import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";

interface Props {}
interface State {}

const TITLE = "Display each note's octave?";
const shortNames = [false, true];
const descriptions = [
  "Each note's loudest octave appears in note history, for example C3 or F#5.",
  "Note history omits octave information, for example C or F#.",
];

function printShortName(x: boolean): string {
  switch (x) {
    case true:
      return "Hide Octave";
    case false:
      return "Show Octave";
  }
}

export default class NoteHideOctaveToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeShowHide = (hideNoteOctave: boolean) => {
    const oldNoteRow = this.context.chordHistoryOptions.noteRow;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { noteRow: { ...oldNoteRow, hideNoteOctave } } });
  };

  render(): ReactNode {
    const hideNoteOctave = this.context.chordHistoryOptions.noteRow.hideNoteOctave;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={hideNoteOctave}
        printShortName={printShortName}
        onChange={this.changeShowHide}
      />
    );
  }
}

NoteHideOctaveToggle.contextType = AppContextType;
